import { includes } from 'lodash/fp'

/** Lodash/fp `includes` where the first arg is the array and the second is the value
 * This is useful with map/filter/reject to pass in the iterated value in a point free way
 */
export function flippedIncludes<T>(arr: T[]): (val: T) => boolean {
  return (val: T): boolean => includes(val)(arr)
}
